import url from 'url';
import * as React from 'react';
import { useTranslator } from '@gandi/translate';
import { Base, Button, Text } from '@gandi/ui';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "heading": "OrderSummary-heading_34X34",
  "ctaButton": "OrderSummary-ctaButton_2Y4C9"
};
export default function OrderSummary(props) {
  const {
    adminURL,
    order,
    sharingId
  } = props;
  const {
    __,
    formatPrice
  } = useTranslator();
  return /*#__PURE__*/_jsxs(Base, {
    backgroundColor: "surface",
    marginBottom: "small",
    tagName: "section",
    flex: true,
    flexCol: true,
    borderRadius: "1x",
    children: [/*#__PURE__*/_jsxs(Base, {
      className: styles.heading,
      flex: true,
      flexColToRow: true,
      flexJustifyBetween: true,
      paddingY: "small",
      gap: "xsmall",
      children: [/*#__PURE__*/_jsx(Base, {
        size: "bigger",
        weight: "semibold",
        paddingX: "small",
        flexGrow1: true,
        children: __('Order summary')
      }), /*#__PURE__*/_jsx("div", {
        className: styles.ctaButton,
        children: /*#__PURE__*/_jsx(Button, {
          marginX: "small",
          small: true,
          iconAfter: "arrowRight",
          kind: "outline",
          href: url.resolve(adminURL, `/billing/${sharingId}/orders/${order.id}`),
          children: __('View order')
        })
      })]
    }), /*#__PURE__*/_jsxs(Base, {
      flex: true,
      flexJustifyBetween: true,
      paddingX: "small",
      marginBottom: "xsmall",
      children: [/*#__PURE__*/_jsx(Base, {
        flex: true,
        flexGrow1: true,
        children: /*#__PURE__*/_jsx(Text, {
          children: __('Total (incl. Taxes)')
        })
      }), /*#__PURE__*/_jsx(Base, {
        children: /*#__PURE__*/_jsx(Text, {
          weight: "semibold",
          children: formatPrice(order.price_after_taxes, order.currency)
        })
      })]
    }), /*#__PURE__*/_jsxs(Base, {
      flex: true,
      flexJustifyBetween: true,
      paddingX: "small",
      marginBottom: "small",
      children: [/*#__PURE__*/_jsx(Base, {
        flexGrow1: true,
        children: /*#__PURE__*/_jsx(Text, {
          children: __('Transaction number')
        })
      }), /*#__PURE__*/_jsx(Base, {
        children: /*#__PURE__*/_jsx(Text, {
          weight: "semibold",
          children: order.id
        })
      })]
    })]
  });
}